import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { tap, map } from 'rxjs/operators';
import {Observable} from 'rxjs';
import { SystemXDetail } from '../models/systemx/SystemXDetail';

@Injectable({
  providedIn: 'root'
})

export class SystemxService {
  cities: any[] ;
  private rootUrl: string;
  constructor(private http: HttpClient) {
     this.rootUrl = ConfService.conf.environment.apiRootUrl;
  }
  
  public GetcitiesData():any[] { 
   var cities= [
      {Name: 'New York', Code: 'NY',LocationID:1},
      {Name: 'Rome', Code: 'RM',LocationID:2},
      {Name: 'London', Code: 'LDN',LocationID:3},
      {Name: 'Istanbul', Code: 'IST',LocationID:4},
      {Name: 'Paris', Code: 'PRS',LocationID:5}  
  ];
  return cities;
  }


  GetSystemxDetails(getSystemXDashboardParam: any): any {
     var data  = [
      { EquipmentID: '489556', Manufacturer: 'HPMAN',Model:'HPModel',IntID:'11',Facility:'ANTU HOSPITAL',EquipmentType:'Physical Plant', EquipmentSubType:'Physical Plant',Status:'active',Description:'data testing',Modality:'Chronic' },
      { EquipmentID: '489557', Manufacturer: 'HPMAN',Model:'HPModel',IntID:'12',Facility:'APEX GROUP OFFICE',EquipmentType:'Physical Plant', EquipmentSubType:'Physical Plant',Status:'active',Description:'data testing',Modality:'Chronic' },
      { EquipmentID: '489558', Manufacturer: 'HPMAN',Model:'HPModel',IntID:'13',Facility:'APEX GROUP OFFICE',EquipmentType:'Physical Plant', EquipmentSubType:'Physical Plant',Status:'active',Description:'data testing',Modality:'Chronic' },
      { EquipmentID: '489559', Manufacturer: 'HPMAN',Model:'HPModel',IntID:'14',Facility:'ANTU HOSPITAL',EquipmentType:'Physical Plant', EquipmentSubType:'Physical Plant',Status:'active',Description:'data testing',Modality:'Chronic' },
      { EquipmentID: '489554', Manufacturer: 'HPMAN',Model:'HPModel',IntID:'15',Facility:'APEX GROUP OFFICE',EquipmentType:'Physical Plant', EquipmentSubType:'Physical Plant',Status:'active',Description:'data testing',Modality:'Chronic' },
      { EquipmentID: '489553', Manufacturer: 'HPMAN',Model:'HPModel',IntID:'16',Facility:'ANTU HOSPITAL',EquipmentType:'Physical Plant', EquipmentSubType:'Physical Plant',Status:'active',Description:'data testing',Modality:'Chronic' },
      { EquipmentID: '489552', Manufacturer: 'HPMAN',Model:'HPModel',IntID:'17',Facility:'APEX GROUP OFFICE',EquipmentType:'Physical Plant', EquipmentSubType:'Physical Plant',Status:'active',Description:'data testing',Modality:'Chronic' },
      { EquipmentID: '489551', Manufacturer: 'HPMAN',Model:'HPModel',IntID:'18',Facility:'ANTU HOSPITAL',EquipmentType:'Physical Plant', EquipmentSubType:'Physical Plant',Status:'active',Description:'data testing',Modality:'Chronic' },

  ];
  return data;
  }

  GetLocationList(getSystemXDashboardParam: any):any{
    var data  = [
      { label: 'Location 01', value: 'Location 01'},
      { label: 'Location 02', value: 'Location 02'},
      { label: 'Location 03', value: 'Location 03'},
      { label: 'Location 04', value: 'Location 04'},
      { label: 'Location 05', value: 'Location 05'},
      { label: 'Location 06 Location 07 Location 08 Location 96', value: 'Location 06 Location 07 Location 08 Location 09'},
      { label: 'Location 07', value: 'Location 07'},
      { label: 'Location 08', value: 'Location 08'},
      { label: 'Location 09', value: 'Location 09'},
      { label: 'Location 10', value: 'Location 10'},
  ];
  return data;

    // var userFacilities : any[];
    // for (let i = 0; i < 10000; i++) {
    //     userFacilities.push({label: 'Item ' + i, value: 'ItemNumber ' + i});
    // }
    // return userFacilities;
  }

  // GET the data for binding the grid control
  GetFilteredFacilityDetails(getSystemXDashboardParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}/Facility/GetFilteredFacilityDetails`,{
      divisionMasterId: getSystemXDashboardParam.divisionMasterId,
      regionMasterId: getSystemXDashboardParam.regionMasterId,
      facilityMasterId: getSystemXDashboardParam.facilityMasterId
    })
      .pipe(
        tap(() => {
          //
        })
      );
  }
}
